import apps from "../services/apps";
import AppService from "../services/apps";

export const REQUEST_FAILED = "REQUEST_FAILED";

export const REQUEST_GET_USER_APPS = "REQUEST_GET_USER_APPS";
export const REQUEST_GET_CUSTOM_APPS = "REQUEST_GET_CUSTOM_APPS";
export const REQUEST_INVALIDATE_APP = "REQUEST_INVALIDATE_APP";
export const REFRESH_USER_APPS = "REFRESH_USER_APPS";
export const REFRESH_CUSTOM_APPS = "REFRESH_CUSTOM_APPS";

export const REQUEST_CREATE_NEW_APP = "REQUEST_CREATE_NEW_APP";
export const REQUEST_CLONE_APP = "REQUEST_CLONE_APP";

export const REQUEST_GET_APP_INFO = "REQUEST_GET_APP_INFO";
export const REQUEST_UPDATE_APP_INFO = "REQUEST_UPDATE_APP_INFO";
export const REQUEST_START_TESTING_APP = "REQUEST_START_TESTING_APP";
export const REFRESH_APP_INFO = "REFRESH_APP_INFO";

export const REQUEST_GET_APP_TEMPLATE = "REQUEST_GET_APP_TEMPLATE";
export const REQUEST_UPDATE_APP_TEMPLATE = "REQUEST_UPDATE_APP_TEMPLATE";
export const REFRESH_APP_TEMPLATE = "REFRESH_APP_TEMPLATE";
export const CLEAR_APP_TEMPLATE = "CLEAR_APP_TEMPLATE";

export const SET_SELECTED_APP = "SET_SELECTED_APP";
export const SET_PROVIDER_APPID = "SET_PROVIDER_APPID";

export const REQUEST_ADD_PROGRAM = "REQUEST_ADD_PROGRAM";
export const REQUEST_UPDATE_PROGRAM = "REQUEST_UPDATE_PROGRAM";
export const REQUEST_DELETE_PROGRAM = "REQUEST_DELETE_PROGRAM";

export const GET_APP_FAVORITES = "GET_APP_FAVORITES";
export const SET_APP_FAVORITES = "SET_APP_FAVORITES";
export const ADD_APP_FAVORITE = "ADD_APP_FAVORITE";
export const DELETE_APP_FAVORITE = "DELETE_APP_FAVORITE";

const requestFailed = (error) => ({
  type: REQUEST_FAILED,
  error,
});

const requestGetUserApps = (userId) => ({
  type: REQUEST_GET_USER_APPS,
  userId,
});

const requestInvalidateApp = (userId, appId) => ({
  type: REQUEST_INVALIDATE_APP,
  userId,
  appId,
});

const refreshUserApps = (apps) => ({
  type: REFRESH_USER_APPS,
  apps,
});

const refreshCustomApps = (customApps) => ({
  type: REFRESH_CUSTOM_APPS,
  customApps,
});

const requestCreateNewApp = (userId, templateId, appInfo) => ({
  type: REQUEST_CREATE_NEW_APP,
  userId,
  templateId,
  appInfo,
});

const requestGetAppInfo = (userId, appId) => ({
  type: REQUEST_GET_APP_INFO,
  userId,
  appId,
});

const requestUpdateAppInfo = (userId, appId, appInfo) => ({
  type: REQUEST_UPDATE_APP_INFO,
  userId,
  appId,
  appInfo,
});

const requestStartTestingApp = (userId, appId) => ({
  type: REQUEST_START_TESTING_APP,
  userId,
  appId,
});

const refreshAppInfo = (userId, appId, appInfo) => ({
  type: REFRESH_APP_INFO,
  userId,
  appId,
  appInfo,
});

const requestGetAppTemplate = (userId, appId, templateId) => ({
  type: REQUEST_GET_APP_TEMPLATE,
  userId,
  appId,
  templateId,
});

const requestUpdateAppTemplate = (userId, appId, appTemplate) => ({
  type: REQUEST_UPDATE_APP_TEMPLATE,
  userId,
  appId,
  appTemplate,
});

const refreshAppTemplate = (userId, appId, appTemplate) => ({
  type: REFRESH_APP_TEMPLATE,
  userId,
  appId,
  appTemplate,
});

const setProviderAppId = (appId) => ({
  type: SET_PROVIDER_APPID,
  appId,
});

const setSelectedApp = (appId) => ({
  type: SET_SELECTED_APP,
  appId,
});

const requestCloneApp = (userId, appId, appInfo) => ({
  type: REQUEST_CLONE_APP,
  userId,
  appId,
  appInfo,
});

const requestGetCustomApps = (userId) => ({
  type: REQUEST_GET_CUSTOM_APPS,
  userId,
});

const requestClearAppTemplate = (userId) => ({
  type: CLEAR_APP_TEMPLATE,
});

const removeAppFromState = (programId) => ({
  type: REQUEST_DELETE_PROGRAM,
  programId,
});

const updateAppInState = (program) => ({
  type: REQUEST_UPDATE_PROGRAM,
  program,
});

const setAppFavorite = (appFavorite) => ({
  type: GET_APP_FAVORITES,
  appFavorite,
});

const requestDeleteAppFavorite = (appId, userId, instructionId) => ({
  type: DELETE_APP_FAVORITE,
  appId,
  userId,
  instructionId,
});

const requestAddAppFavorite = (appId, userId, instructionId) => ({
  type: ADD_APP_FAVORITE,
  appId,
  userId,
  instructionId,
});

export const clearAppTemplateFromStore = () => async (dispatch) => {
  dispatch(requestClearAppTemplate());
};

export const getUserApps = (userId) => async (dispatch) => {
  if (userId < 1) {
    return;
  }

  dispatch(requestGetUserApps(userId));

  try {
    const resp = await AppService().getUserApps(userId);

    if (resp.apps) {
      dispatch(refreshUserApps(resp.apps));
    } else {
      dispatch(requestFailed("Unable to get user apps!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const createNewApp =
  (userId, templateId, appInfo) => async (dispatch) => {
    dispatch(requestCreateNewApp(userId, templateId, appInfo));

    try {
      const resp = await AppService().createNewApp(
        userId,
        templateId,
        appInfo,
        "AC HEALTH PORTAL"
      );

      if (resp.appId) {
        // refresh app template
        dispatch(refreshAppTemplate(userId, resp.appId, resp.appTemplate));
        // refresh app info
        dispatch(refreshAppInfo(userId, resp.appId, resp.appInfo));
        // set app ID (indicates app created)
        dispatch(setSelectedApp(resp.appId));
      } else {
        dispatch(requestFailed("Unable to create new app!"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const getAppInfo = (userId, appId) => async (dispatch) => {
  dispatch(requestGetAppInfo(userId, appId));

  try {
    const resp = await AppService().getAppInfo(userId, appId);
    if (resp.appInfo) {
      dispatch(refreshAppInfo(userId, appId, resp.appInfo));
    } else {
      dispatch(requestFailed("Unable to get app info!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const updateAppInfo = (userId, appId, appInfo) => async (dispatch) => {
  dispatch(requestUpdateAppInfo(userId, appId, appInfo));

  try {
    const resp = await AppService().updateAppInfo(userId, appId, appInfo);

    if (resp.appInfo) {
      dispatch(refreshAppInfo(userId, appId, resp.appInfo));
    } else {
      dispatch(requestFailed("Unable to update app info!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const startTestingApp = (userId, appId) => async (dispatch) => {
  dispatch(requestStartTestingApp(userId, appId));

  try {
    const resp = await AppService().startTestingApp(userId, appId);

    if (resp.appInfo) {
      dispatch(refreshAppInfo(userId, appId, resp.appInfo));
    } else {
      dispatch(requestFailed("Unable to start testing app!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const getAppTemplate =
  (userId, appId, templateId) => async (dispatch) => {
    dispatch(requestGetAppTemplate(userId, appId, templateId));

    try {
      const resp = await AppService().getAppTemplate(userId, appId, templateId);
      if (resp.appTemplate) {
        updateAppTemplate(userId, appId, resp.appTemplate);
        dispatch(
          refreshAppTemplate(userId, appId, {
            userId: userId,
            appId: appId,
            templateId: resp.appTemplate.templateId,
            ...resp.appTemplate.template,
          })
        );
      } else {
        dispatch(requestFailed("Unable to get app template!"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const updateAppTemplate =
  (userId, appId, appTemplate) => async (dispatch) => {
    dispatch(requestUpdateAppTemplate(userId, appId, appTemplate));

    try {
      const resp = await AppService().updateAppTemplate(
        userId,
        appId,
        appTemplate
      );

      if (resp.appTemplate) {
        dispatch(
          refreshAppTemplate(userId, appId, {
            userId: userId,
            appId: appId,
            templateId: resp.appTemplate.templateId,
            ...resp.appTemplate.template,
          })
        );
      } else {
        dispatch(requestFailed("Unable to update app template!"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const invalidateApp = (userId, appId) => async (dispatch) => {
  dispatch(requestInvalidateApp(userId, appId));

  try {
    const resp = await AppService().invalidateApp(userId, appId);

    if (resp.apps) {
      dispatch(refreshUserApps(resp.apps));
    } else {
      dispatch(requestFailed("Unable invalidate app!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const selectApp = (appId) => async (dispatch) => {
  dispatch(setSelectedApp(appId));
};

export const providerAppId = (appId) => async (dispatch) => {
  dispatch(setProviderAppId(appId));
};

export const cloneApp = (userId, appId, appInfo) => async (dispatch) => {
  dispatch(requestCloneApp(userId, appId, appInfo));

  try {
    const resp = await AppService().cloneApp(userId, appId, appInfo);

    if (resp.apps) {
      dispatch(refreshUserApps(resp.apps));
    } else {
      dispatch(requestFailed("Unable to clone app!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const getCustomApps = (userId) => async (dispatch) => {
  if (userId < 1) {
    return;
  }

  dispatch(requestGetCustomApps(userId));

  try {
    const resp = await AppService().getCustomApps(userId);

    if (resp.userApps) {
      dispatch(refreshCustomApps(resp.userApps));
    } else {
      dispatch(requestFailed("Unable to get custom apps!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const addProgram = (appId, userId, program) => async (dispatch) => {
  try {
    const resp = await AppService().addProgram(appId, userId, program);

    if (resp.program) {
      // refresh app template
      program = resp.program;
      dispatch(updateAppInState(program));
    } else {
      dispatch(requestFailed("Unable to add program to app!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const updateProgram = (appId, userId, program) => async (dispatch) => {
  try {
    const resp = await AppService().updateProgram(appId, userId, program);

    if (resp) {
      dispatch(updateAppInState(program));
    } else {
      dispatch(requestFailed("Unable to update program to app!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const deleteProgram = (appId, userId, programId) => async (dispatch) => {
  try {
    let resp = await AppService().deleteProgram(appId, userId, programId);

    if (resp.response === "ok") {
      dispatch(removeAppFromState(programId));
    } else {
      dispatch(requestFailed("Unable to remove program from app!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const getAppFavorites = (appId, userId) => async (dispatch) => {
  try {
    const response = await AppService().getAppFavorites(appId, userId);
    if (response !== null) {
      dispatch(setAppFavorite(response));
    } else {
      dispatch(requestFailed("Unable to fetch app favorites!"));
      dispatch(
        setAppFavorite({
          appId,
          userId,
          instructions: [],
          created: new Date(),
          modified: new Date(),
        })
      );
    }
  } catch (error) {
    console.error("Unable to fetch app favorite", error);
    dispatch(requestFailed("Internal error!"));
  }
};

export const addAppFavorite =
  (appId, userId, instructionId) => async (dispatch) => {
    try {
      const resp = await AppService().addAppFavorite(
        appId,
        userId,
        instructionId
      );

      if (resp.response == "ok") {
        dispatch(requestAddAppFavorite(appId, userId, instructionId));
      } else {
        dispatch(requestFailed("Unable to fetch app favorites!"));
      }
    } catch (error) {
      console.error("Unable to add app favorite", error);
      dispatch(requestFailed("Internal error!"));
    }
  };

export const deleteAppFavorite =
  (appId, userId, instructionId) => async (dispatch) => {
    try {
      const resp = await AppService().deleteAppFavorite(
        appId,
        userId,
        instructionId
      );

      if (resp.response == "ok") {
        dispatch(requestDeleteAppFavorite(appId, userId, instructionId));
      } else {
        dispatch(requestFailed("Unable to fetch app favorites!"));
      }
    } catch (error) {
      console.error("Unable to delete app favorite", error);
      dispatch(requestFailed("Internal error!"));
    }
  };



// WEBPACK FOOTER //
// ./src/actions/apps.js